export const routes = [
  {
    path: '/',
    name: 'login',
    meta: {
      title: 'Se connecter',
      layout: 'TwoColumns',
      isPublic: true
    },
    component: () => import('../views/Login.vue')
  },
  {
    path: '/premiere-connexion/',
    name: 'firstConnection',
    meta: {
      title: 'Première connexion',
      layout: 'TwoColumns',
      isPublic: true
    },
    component: () => import('../views/FirstConnection.vue'),
    props: true
  },
  {
    path: '/premiere-connexion/:token',
    name: 'activateAccount',
    meta: {
      title: 'Activation du compte',
      layout: 'TwoColumns',
      isPublic: true
    },
    component: () => import('../views/Login.vue'),
    props: true
  },
  {
    path: '/mot-de-passe-oublie',
    name: 'forgotPassword',
    meta: {
      title: 'Mot de passe oublié ?',
      layout: 'TwoColumns',
      isPublic: true
    },
    component: () => import('../views/ForgotPassword.vue')
  },
  {
    path: '/mot-de-passe-oublie/:token',
    name: 'resetPassword',
    meta: {
      title: 'Réinitialisation du mot de passe',
      layout: 'TwoColumns',
      isPublic: true
    },
    component: () => import('../views/ResetPassword.vue'),
    props: true
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      title: 'Déconnexion'
    },
    notInSitemap: true,
    component: () => import('../views/Logout.vue')
  },
  {
    path: '/accueil',
    name: 'home',
    meta: {
      title: 'Télécharger la liste des assistants maternels'
    },
    component: () => import('../views/Home.vue')
  },
  {
    path: '/accessibilite',
    name: 'accessibilite',
    meta: {
      title: 'Accessibilité'
    },
    component: () => import('../views/Accessibilite.vue')
  },
  {
    path: '/mon-compte',
    name: 'monCompte',
    meta: {
      title: 'Mon compte',
      requiresAuth: true
    },
    component: () => import('../views/MonCompte.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    meta: {
      title: 'Contact',
      requiresAuth: true
    },
    component: () => import('../views/Contact.vue')
  },
  {
    path: '*',
    name: '404',
    meta: {
      title: 'Page non trouvée',
      layout: 'TwoColumns',
      isPublic: true
    },
    component: () => import('../views/PageNotFound.vue')
  },
]